import { render, staticRenderFns } from "./OauthTypeNotice.vue?vue&type=template&id=0d8e7749&"
import script from "./OauthTypeNotice.vue?vue&type=script&lang=ts&"
export * from "./OauthTypeNotice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports